import { UserService } from "./services/UserService";

const apiUrl = process.env.REACT_APP_API_URL;

export const userService = new UserService(apiUrl);
